module.exports = __webpack_public_path__ + "img/img14.729778ac.svg";